// extracted by mini-css-extract-plugin
export default {"root":"VirtualMasonryGridCellSkeleton-module__root_SemS9","skeletonWave":"VirtualMasonryGridCellSkeleton-module__skeletonWave_oFs03"};